<div class="row">
    <div class="col-12">

        <div class="card">

            <div class="card-header">
                <div class="title">{{ 'SETTINGS' | translate }}</div>
                <div class="tools">
                    <button type="button" class="btn btn-light btn-sm" routerLink="/integration">
                        <i class="bi bi-backspace"></i> {{ 'BACK_TO_LIST' | translate }}
                    </button>
                    <button type="button" class="btn btn-primary btn-sm" (click)="onSave()" [disabled]="uploadForm.invalid || loading">
                        <i class="bi bi-save"></i> {{ 'SAVE' | translate }}
                    </button>
                </div>
            </div>

            <div class="card-body">

                <div class="card-body-title">{{ 'INTEGRATION.CONECTION_OPTIONS_TO' | translate }} Kaspi</div>

                <form class="form" #f="ngForm" [formGroup]="uploadForm" autocomplete="off">

                    <div class="row">

                        <div class="col-6 form-group">
                            <label for="company" class="label"><span class="star">*</span> {{ 'COMPANY.COMPANY' | translate }}</label>
                            <input type="text" class="form-control" id="company" formControlName="company">
                            <div *ngIf="errorMessages">
                                <div *ngFor="let item of errorMessages.company">
                                    <div class="text-error" *ngIf="validation('company', item.type)">
                                        {{ item.message | translate: item.options }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-6 form-group">
                            <label for="merchantId" class="label"><span class="star">*</span> {{ 'INTEGRATION.MERCHANT' | translate }} ID</label>
                            <input type="text" class="form-control" id="merchantId" formControlName="merchantId">
                            <div *ngIf="errorMessages">
                                <div *ngFor="let item of errorMessages.merchantId">
                                    <div class="text-error" *ngIf="validation('merchantId', item.type)">
                                        {{ item.message | translate: item.options }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-6 form-group">
                            <label for="apikey" class="label"><span class="star">*</span> API {{ 'INTEGRATION.KEY' | translate }}</label>
                            <input type="text" class="form-control" id="apikey" formControlName="apikey">
                            <div *ngIf="errorMessages">
                                <div *ngFor="let item of errorMessages.apikey">
                                    <div class="text-error" *ngIf="validation('apikey', item.type)">
                                        {{ item.message | translate: item.options }}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </form>

            </div>

        </div>

    </div>
</div>